import { createContext, useContext } from 'react';

export const ThemeContext = createContext({
    logo: null,
});

export const useThemeContext = () => useContext(ThemeContext);

export default ThemeContext;